import { render, staticRenderFns } from "./InfiniteLoader.vue?vue&type=template&id=6e8ef246"
import script from "./InfiniteLoader.vue?vue&type=script&lang=ts"
export * from "./InfiniteLoader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports